<template>
	<div>
		<div v-if="inPrint == 0" v-loading="loadings.main">
			<h3>吊牌打印</h3>
			<print-items v-model="info.items"></print-items>
			<div class="btn-holder mt-5 text-center" >
				<el-button
					size
					type="success"
					:disabled="info.items.length == 0"
					@click="gotoPrint()"
					>进入打印</el-button
				>
			</div>
			<hr />
			<items
				class="mt-3"
				@insert="onInsertItems($event)"
				:is-need-cost="false"
				:is-use-price="false"
				:has-select-all="true"
			></items>
		</div>
		<div v-else>
			<print-sticker :items="info.items"></print-sticker>
		</div>
	</div>
</template>
<script>
import Order from "@/mixinsApp/Order.js";
import TxOp from "@/mixinsApp/TxOp.js";
import PrintItems from "@/views/Inventory/subs/PrintItems.vue";
import PrintSticker from "@/views/Inventory/widgets/PrintSticker.vue";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	mixins: [Order, TxOp],
	components: {
		PrintItems,PrintSticker
	},
	config: {
		adminFilter: [
			{
				k: "is_leave",
				t: "bool",
				v: 0,
			},
			{
				k: "is_saler",
				t: "bool",
				v: 1,
			},
		],
	},
	data() {
		return {
			inPrint: 0,
			loadings: {
				main: false,
				create: false,
				insert: false,
				customer: false,
			},
			printers: [],
			selected_printer: "",
			printer_err: "",
			info: {
				items: [],
			},

			defaultValue: {},
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},

	props: {
		value: {
			type: Object,
			default: null,
		},
	},
	created() {
		
	},
	mounted() {
		let externalScript = document.createElement("script");
		externalScript.setAttribute("src", "https://cdn.jsdelivr.net/gh/gildas-lormeau/zip.js/dist/zip-full.min.js");
		document.head.appendChild(externalScript);
	},
	methods: {
		
		handleOrderEdited(key) {},
		doResetAll() {
			// this.initInfo();
		},
		gotoPrint() {
			this.inPrint = 1;
		},
		
	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					this.info = Object.assign({}, val);
				}
			},
			immediate: true,
		},
	},
};
</script>
<style>
.el-radio-button--mini .el-radio-button__inner {
	padding: 7px 7px;
}


</style>
